import { useTranslation } from 'react-i18next';
import { Namespace, ParseKeys } from 'i18next';

export default (
  keyValue: string,
  translationValue: string,
  defaultValue?: string,
) => {
  const key = `${keyValue}.${translationValue}`;
  const { t } = useTranslation<Namespace<'book'>>('book');

  if (defaultValue) {
    return t(key as ParseKeys<Namespace<'book'>>, defaultValue);
  } else {
    return t(key as ParseKeys<Namespace<'book'>>);
  }
};
